import Typography from '@mui/material/Typography'
import type { GridPaginationModel } from '@mui/x-data-grid-premium'
import { useCallback, useState } from 'react'
import FigmaBox from '../../../mynt-components/components/FigmaBox'
import { useFraudCases } from '../api/useFraudCases'
import type { ListFraudCasesParams } from '../types'
import { FraudCasesFilters } from './FraudCasesFilters'
import { FraudCasesTable } from './FraudCasesTable'

type FraudCasesPageProps = {
  caseId?: string
  onReset?: () => void
}

export const FraudCasesPage = ({ caseId, onReset }: FraudCasesPageProps) => {
  const defaultFilters: Partial<ListFraudCasesParams> = caseId ? { 'case-id': caseId } : { status: ['NEW', 'NOTIFIED'] }

  const [filters, setFilters] = useState<Partial<ListFraudCasesParams>>(defaultFilters)
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({ page: 0, pageSize: 10 })

  const params: ListFraudCasesParams = {
    pageSize: paginationModel.pageSize,
    page: paginationModel.page + 1,
    ...filters,
  }

  const { data, isFetching } = useFraudCases(params)
  const cases = data?.cases ?? []

  const handlePaginationModelChange = useCallback((model: GridPaginationModel) => {
    setPaginationModel(model)
  }, [])

  const initialFieldValues = caseId ? { 'case-id': caseId } : undefined

  return (
    <FigmaBox fullWidth gap="24px">
      <Typography variant="h2">Fraud cases</Typography>
      <FraudCasesFilters
        fields={['case-id', 'customer-id', 'card-id', 'person-id', 'external-id']}
        defaultStatus={caseId ? [] : undefined}
        initialFieldValues={initialFieldValues}
        onReset={onReset}
        onSearch={(newFilters) => {
          setFilters(newFilters)
          setPaginationModel((prev) => ({ ...prev, page: 0 }))
        }}
      />
      <FraudCasesTable
        cases={cases}
        isLoading={isFetching}
        initialExpandedCaseId={caseId}
        rowCount={data?.pagination?.totalItems ?? 0}
        paginationModel={paginationModel}
        onPaginationModelChange={handlePaginationModelChange}
      />
    </FigmaBox>
  )
}
